/**
 * Razorpay Checkout in the browser. The script is loaded on first use only,
 * so pages that never take payment never download it.
 */

const CHECKOUT_SRC = "https://checkout.razorpay.com/v1/checkout.js"

let loading = null

const loadCheckout = () => {
    if (window.Razorpay) return Promise.resolve()
    if (!loading) {
        loading = new Promise((resolve, reject) => {
            const script = document.createElement("script")
            script.src = CHECKOUT_SRC
            script.async = true
            script.onload = () => resolve()
            script.onerror = () => {
                loading = null
                script.remove()
                reject(new Error("load"))
            }
            document.body.appendChild(script)
        })
    }
    return loading
}

/** Thrown when the student closes Checkout without paying. */
export class CheckoutDismissed extends Error {}

/**
 * Opens Checkout for a server-created order.
 *
 * @param {Object} order  the `/order` response: key_id, order_id, amount,
 *                        currency, course_title, prefill
 * @returns {Promise<{razorpay_order_id, razorpay_payment_id, razorpay_signature}>}
 *          resolves once Razorpay reports a successful payment; rejects with
 *          CheckoutDismissed if the student closes it, or an Error on failure.
 */
export const openCheckout = async (order) => {
    await loadCheckout()

    return new Promise((resolve, reject) => {
        const checkout = new window.Razorpay({
            key: order.key_id,
            order_id: order.order_id,
            amount: order.amount,
            currency: order.currency,
            name: "Lecture portal",
            description: order.course_title,
            prefill: order.prefill,
            theme: { color: "#4f46e5" },
            handler: resolve,
            modal: {
                ondismiss: () => reject(new CheckoutDismissed())
            }
        })

        /*
         * A failed attempt is not final -- Checkout stays open so the student
         * can retry with another method. Only closing it ends the flow.
         */
        checkout.open()
    })
}
